import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=ffed357a&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=ffed357a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffed357a",
  null
  
)

/* custom blocks */
import block0 from "./Contact.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(component)
import block1 from "./Contact.vue?vue&type=custom&index=1&blockType=div"
if (typeof block1 === 'function') block1(component)

export default component.exports